

export default function UserRounded({name, lastname}: {name: string, lastname: string}) {    

    return(
        <div className="rounded-full h-12 w-12 min-w-[48px] min-h-[48px] bg-[#064e3b] flex items-center justify-center text-white">
            {name?.charAt(0)?.toUpperCase()}{lastname?.charAt(0)?.toUpperCase()}
        </div>
    )
}